export const translation = {
    msgError500: 'مشکلی در ارتباط با سرور رخ داده است',
    msgError404: 'آدرس مورد نظر یافت نشد',
}